import { render, staticRenderFns } from "./VabSubmenu.vue?vue&type=template&id=1a5d310c"
import script from "./VabSubmenu.vue?vue&type=script&lang=js"
export * from "./VabSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports